import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'

type CreatePasswordBody = {
  password: string
}

export async function createPassword(body: CreatePasswordBody) {
  const response = await httpClient('user-manager').post(
    '/v1/user/me/password',
    body,
  )

  return response.data
}

export function useCreatePassword(
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    CreatePasswordBody,
    unknown
  >,
) {
  return useMutation({
    mutationFn: createPassword,
    ...options,
  })
}
